import getHelper from '../../../services/getHelper';
import type { StudentDashboard } from '../../../../../index';

export default getHelper<StudentDashboard>('/students/:id', {
  dashboard: getHelper('/dashboard'),
});
